import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";

const ToolsListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  margin: 60px 0;
  gap: 1rem 3rem;
  @media (max-width: 770px) {
    margin-top: 10px;
  }
`;
const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  position: relative;
  z-index: 5;
  width: 47%;
  @media (max-width: 770px) {
    &:nth-child(n + 5) {
      display: none;
    }
  }
  @media (max-width: 440px) {
    padding: 15px 0;
    width: 100%;
  }
`;
const Icon = styled(ImageLibpixel)`
  width: 85px;
  height: 80px;
  object-fit: contain;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 2px 5px 14px rgba(0, 0, 0, 0.16);
`;
const TextBox = styled.div`
  padding-left: 20px;
  max-height: 85px;
  @media (max-width: 440px) {
    height: auto;
  }
`;
const Title = styled.h3`
  font-size: 1rem;
  display: flex;
  margin: 0 0 5px 0;
  text-align: center;
  font-weight: 800;
  letter-spacing: 1px;
  text-decoration: none;
`;
const Description = styled.p`
  font-size: 0.8rem;
  margin: 0;
  line-height: 1.4;
  overflow: hidden;
`;

const ToolsList = ({ columns }) => {
  return (
    <ToolsListWrapper>
      {columns.map((node, i) => (
        <ContentBox key={i + 1}>
          <Icon src={node.img?.sourceUrl} alt={node.title} />
          <TextBox>
            <Title>{node.title}</Title>
            <Description>{node.text}</Description>
          </TextBox>
        </ContentBox>
      ))}
    </ToolsListWrapper>
  );
};

ToolsList.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      img: PropTypes.shape({
        sourceUrl: PropTypes.string,
      }),
    })
  ),
  posts: PropTypes.object,
};

ToolsList.defaultProps = {
  columns: undefined,
};

export default ToolsList;
